import { LocalEvent } from "./Actions/LocalEvent";

class Dispatcher {
    public static dispatch(operation: number, params: any = {}, delayms: number = null): void {
        function action(): void {
            let localEvent = new LocalEvent(operation);
            if (params != null)
                Object.keys(params).forEach(param => localEvent.AddItem(param, params[param]));

            LocalEventDispatcher.dispatch(localEvent);
        }

        if (delayms != null)
            window.setTimeout(action, delayms);
        else
            action();
    }
}

export { Dispatcher };
